import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { CompanyCountryId } from '../types/companyCountryId'

const companyCountryIds: CompanyCountryId[] = ['DE', 'FR', 'NL', 'DK']

export const isCompanyCountryId = (countryId: Organization['countryId'] | string): countryId is CompanyCountryId =>
  companyCountryIds.some((companyCountryId) => companyCountryId === countryId)
